import React, { useEffect, useState } from "react";
import styles from "./returned.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { getDropdownListMonths } from "../../../../_utils/mapTransactions";
import {
  getDropdownListYears,
  getWeeksOfYear,
} from "../../../../_utils/getReportsDateOptions";
import { getStatistics } from "../../../../_services/statistics.service";
import Selector from "../../../selector";
import Loading from "../../../loading";
import LineChart from "../../../charts/line";
import { mainActions } from "../../../../_store/actions/main.actions";
import { makeSelectMap } from "../../../../_utils/utils";

const UsageReturnedChart = () => {
  const store = useSelector((state) => state);
  const dispatch = useDispatch();

  const [loadingData, setLoadingData] = useState(true);
  const [locationOptions, setLocationOptions] = useState([]);
  const [weeksOptions, setWeeksOptions] = useState([]);
  const [monthsOptions, setMonthsOptions] = useState([]);
  const [yearsOptions, setYearsOptions] = useState([]);
  const [numberOfReturned, setNumberOfReturned] = useState();
  const [containerTypeOptions, setContainerTypeOptions] = useState([]);

  const [statisticsFilter, setStatisticsFilter] = useState({
    period: "daily",
    startOfWeek: "",
    month: "",
    year: "",
    locationId: "",
    containerTypeId: "",
  });
  const [arrayForLineChart, setarrayForLineChart] = useState([]);
  useEffect(() => {
    const arrYears = getDropdownListYears(2023);
    const year = arrYears[0].value;
    setYearsOptions(arrYears);
    setStatisticsFilter((prev) => ({
      ...prev,
      year: year,
    }));
  }, []);

  const periodOptions = [
    { value: "daily", label: "Daily" },
    { value: "weekly", label: "Weekly" },
    { value: "monthly", label: "Monthly" },
    { value: "yearly", label: "Yearly" },
    { value: "all", label: "All Time" },
  ];
  useEffect(() => {
    if (statisticsFilter.year) {
      const arr = getDropdownListMonths(statisticsFilter.year, true);
      setMonthsOptions(arr);

      const weeks = getWeeksOfYear(statisticsFilter.year);
      setWeeksOptions(weeks);

      setStatisticsFilter((prev) => ({
        ...prev,
        month: arr[0].value,
        startOfWeek: weeks[0].value,
      }));
    }
  }, [statisticsFilter.year]);

  useEffect(() => {
    setLoadingData(true);
    const getData = async (subregionId, data) => {
      data.subregionId = subregionId;

      const response = await getStatistics({
        mode: "get-subregion-return-statistics",
        filter: data,
      });
      if (response) {
        setarrayForLineChart(response.array || []);
        setNumberOfReturned(response.total);
      }
      setLoadingData(false);
    };
    if (
      store.auth &&
      store.auth.user &&
      store.auth.user.subregionId &&
      statisticsFilter.year &&
      ((statisticsFilter.period === "weekly" && statisticsFilter.startOfWeek) ||
        statisticsFilter.month ||
        statisticsFilter.month === 0) &&
      statisticsFilter.period
    ) {
      getData(store.auth.user.subregionId, statisticsFilter);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statisticsFilter]);
  useEffect(() => {
    const getRestaurants = async (id) => {
      let filter = [];
      if (id) filter.push({ subregionId: id });
      let data = await dispatch(
        mainActions.run("data", "location", "all", { filter })
      );
      if (data) {
        let arr = makeSelectMap(data);
        let filterOptions = [...arr];
        filterOptions.unshift({ label: "All Locations", value: "" });
        setLocationOptions(filterOptions);
      }
    };
    const fetchAllContainerTypes = async (subregionId) => {
      let data = await dispatch(
        mainActions.run("data", "containerType", "all", {
          filter: [{ subregionId }],
        })
      );
      let arr = makeSelectMap(data);
      let filterOptions = [...arr];
      filterOptions.unshift({ label: "All Containers", value: "" });
      setContainerTypeOptions(filterOptions);
    };
    if (store.auth && store.auth.user && store?.auth?.user?.subregionId) {
      getRestaurants(store?.auth?.user?.subregionId);
      fetchAllContainerTypes(store?.auth?.user?.subregionId);
    }
  }, [store.auth && store.auth.user]);

  const getSelectedValue = (options, value) => {
    const selectedData = [];
    options &&
      options.forEach((obj) => {
        if (obj.value === value) {
          selectedData.push(obj);
        }
      });
    return selectedData;
  };
  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <div className={styles.select}>
          <Selector
            label=""
            placeholder="All Locations"
            multiselect={false}
            selectClassname="selectGray"
            options={locationOptions}
            disabled={loadingData}
            handleChangeSelect={(e) =>
              setStatisticsFilter((prev) => ({
                ...prev,
                locationId: e.value,
              }))
            }
          />
        </div>
        <div className={styles.select}>
          <Selector
            label=""
            placeholder="All Containers"
            multiselect={false}
            selectClassname="selectGray"
            options={containerTypeOptions}
            disabled={loadingData}
            handleChangeSelect={(e) =>
              setStatisticsFilter((prev) => ({
                ...prev,
                containerTypeId: e.value,
              }))
            }
          />
        </div>
        <div className={styles.row}>
          <div className={styles.icon}>
            <div>
              <span>{numberOfReturned || "0"}</span>
            </div>
            <span>Returned</span>
          </div>
          <div className={styles.selectDate}>
            <div className={styles.selectPeriod}>
              <Selector
                label=""
                multiselect={false}
                selectClassname="selectGray"
                selectedOption={getSelectedValue(
                  periodOptions,
                  statisticsFilter.period
                )}
                handleChangeSelect={(e) =>
                  setStatisticsFilter((prev) => ({
                    ...prev,
                    period: e.value,
                  }))
                }
                options={periodOptions}
                disabled={loadingData}
              />
            </div>
            {statisticsFilter.period === "weekly" ? (
              <div className={`${styles.selectWeek}`}>
                <Selector
                  label=""
                  multiselect={false}
                  selectClassname="selectGray"
                  selectedOption={getSelectedValue(
                    weeksOptions,
                    statisticsFilter.startOfWeek
                  )}
                  handleChangeSelect={(e) =>
                    setStatisticsFilter((prev) => ({
                      ...prev,
                      startOfWeek: e.value,
                    }))
                  }
                  options={weeksOptions}
                  disabled={loadingData}
                />
              </div>
            ) : (
              <div
                className={`${styles.selectMonth} ${
                  statisticsFilter.period !== "daily"
                    ? styles.selectDisabled
                    : ""
                }`}
              >
                <Selector
                  label=""
                  multiselect={false}
                  selectClassname="selectGray"
                  selectedOption={getSelectedValue(
                    monthsOptions,
                    statisticsFilter.month
                  )}
                  handleChangeSelect={(e) =>
                    setStatisticsFilter((prev) => ({
                      ...prev,
                      month: e.value,
                    }))
                  }
                  options={monthsOptions}
                  disabled={loadingData || statisticsFilter.period !== "daily"}
                />
              </div>
            )}
            <div
              className={`${styles.selectYear} ${
                ["yearly", "all"].includes(statisticsFilter.period)
                  ? styles.selectDisabled
                  : ""
              }`}
            >
              <Selector
                label=""
                multiselect={false}
                selectClassname="selectGray"
                selectedOption={getSelectedValue(
                  yearsOptions,
                  statisticsFilter.year
                )}
                handleChangeSelect={(e) =>
                  setStatisticsFilter((prev) => ({
                    ...prev,
                    year: e.value,
                  }))
                }
                options={yearsOptions}
                disabled={
                  loadingData ||
                  ["yearly", "all"].includes(statisticsFilter.period)
                }
              />
            </div>
          </div>
        </div>
      </div>
      <div className={styles.chartWrapper}>
        {loadingData && (
          <div className={styles.loading}>
            <Loading width={50} height={50} />
          </div>
        )}
        {!loadingData && !arrayForLineChart.length && (
          <div className={styles.noReturnedMsg}>
            There are no returned containers
          </div>
        )}
        {!loadingData && arrayForLineChart.length > 0 && (
          <div className={styles.bigChartSection}>
            <LineChart arrayForLineChart={arrayForLineChart} />
          </div>
        )}
      </div>
    </div>
  );
};

export default UsageReturnedChart;
